import { apolloClient } from "../../vue-apollo";
import {
    GET_YEAR_GALERIAS, 
    GET_MONTH_FOR_GALERIAS,
    GET_GALERIA_MES_YEAR,
    GET_GALERIA,
    GET_PAGINAS_IMAGENES_GALERIAS,
    GET_IMAGENES_GALERIA
} from "../../graphql/queries";
import {
    DAR_LIKE,
    QUITAR_LIKE,
    // DAR_LIKE_GALERIA,
    // QUITAR_LIKE_GALERIA
} from "../../graphql/mutations";

export default {
    namespaced: true,
    state: {
        yearGaleria: [],
        monthGaleria: [],
        galeriasMesYear: [],
        galeria: [],
        imagenes: [], 
        paginasGalerias: []
    },
    getters: {
    },
    mutations: {
        
        SET_YEAR(state, year){
            state.yearGaleria = year;
        },
        SET_MONTH_GALERIA(state, monGaleria){
            state.monthGaleria = monGaleria;
        },

        SET_GALERIA_MES_YEAR(state, galerias){
            state.galeriasMesYear = galerias;
        },

        SET_GALERIA(state, data){
            state.galeria = data;
        },

        SET_LIKE_IMAGEN_GALERIA(state, likeImagen){
            // console.log('GALERIA mutada', likeImagen.imagenes);
            // console.log('galeria sin mutar', state.galeria.imagenes);
            let indexImagen = state.imagenes.findIndex(x => x.id_imagen == likeImagen.data.id_subobjeto);
            console.log(indexImagen);
            if (likeImagen.action) {
                state.imagenes[indexImagen].likes.push(likeImagen.likeImagen);
                state.imagenes[indexImagen].confirm_like = likeImagen.likeImagen;
            } else {
                state.imagenes[indexImagen].likes = state.imagenes[indexImagen].likes.filter(x => x.id_like !== likeImagen.likeImagen.id_like);
                state.imagenes[indexImagen].confirm_like = null;
            }
            console.log("valores", state, likeImagen)
            // state.imagenes = likeImagen.imagenes;
        },

        SET_PAGINAS_GALERIA(state, paginas){
            state.paginasGalerias = paginas;
        },

        // SET_IMAGENES_GALERIA(state, imagenes) {
        //     console.log(state, imagenes)
        //     state.imagenes = imagenes;
        // }

        SET_IMAGENES(state, imagenes) {
            console.log(state, imagenes)
            state.imagenes = imagenes;
        }

    },
    actions: {
        async getYearGaleria({ commit }, data_) {
            let response = null;
            let params = {
                query: GET_YEAR_GALERIAS,
                variables: data_
            }
            try {
            await apolloClient.query(params).then(res => {
                //console.log("respuest de server getYearGaleria: ", res.data.yearGaleria);
                if (!res.loading) response = res.data.yearGaleria;
            });
            }
            catch(e){
            console.log("Falla error, getYearGaleria ", e);
            }
            return new Promise((resolve)=>{
                if(response!=null){
                    if (response.length==0){
                        resolve(false);
                    }
                    else {
                        resolve(response);
                        commit("SET_YEAR", response);
                    }
                }
                else {
                    resolve(false);
                }
            });
            
            
        },

        async getGaleriaMonth({ commit }, data_){
            let response = null;
            let params = {
                query: GET_MONTH_FOR_GALERIAS,
                variables: data_
            }
            try {
            await apolloClient.query(params).then(res => {
                //console.log("respuest de server getGaleriaMonth: ", res.data.monthGaleria);
                if (!res.loading) response = res.data.monthGaleria;
            });
            }
            catch(e){
            console.log("Falla error, getGaleriaMonth ", e);
            }
            return new Promise((resolve)=>{
                if(response!=null){
                    if (response.length==0){
                        resolve(false);
                    }
                    else {
                        resolve(response);
                        commit("SET_MONTH_GALERIA", response);
                    }
                }
                else {
                    resolve(false);
                }
            });
        },

        async getGaleriaMesYear({ commit }, data_){
            let response = null;
            let params = {
                query: GET_GALERIA_MES_YEAR,
                variables: data_
            }
            try {
            await apolloClient.query(params).then(res => {
                //console.log("respuest de server getGaleriaMonthYear: ", res.data.galeriasMesYear);
                if (!res.loading) response = res.data.galeriasMesYear;
            });
            }
            catch(e){
            console.log("Falla error, getGaleriaMonthYear ", e);
            }
            return new Promise((resolve)=>{
                if(response!=null){
                    commit("SET_GALERIA_MES_YEAR", response);
/*                     if (response.length==0){
                        resolve(false);
                    }
                    else {
                        resolve(response);
                        commit("SET_GALERIA_MES_YEAR", response);
                    } */
                }
                else {
                    resolve(false);
                }
            });
        },

        async getGaleria({ commit }, data_) {
            let response = null;
            let params = {
                query: GET_GALERIA,
                variables: data_
            }
            try {
            await apolloClient.query(params).then(res => {
                //console.log("respuest de server getGaleria: ", res.data.galeria);
                if (!res.loading) response = res.data.galeria;
            });
            }
            catch(e){
            console.log("Falla error, getGaleria ", e);
            }
            return new Promise((resolve)=>{
                if(response!=null){
                    if (response.length==0){
                        resolve(false);
                    }
                    else {
                        resolve(response);
                        commit("SET_GALERIA", response);
                    }
                }
                else {
                    resolve(false);
                }
            });
            
            
        },

        async addLikeGaleria({commit}, data_){
            let response = null;
            let data = [];
            let params = {
                mutation: DAR_LIKE,
                variables: data_
            }
            try{
                await apolloClient.mutate(params).then(res => {
                    //console.log('SET_LIKE_IMAGEN_GALERIA', res.data.darLikeImagen);
                    if (!res.loading) data = res.data.agregarLikesEmpresa;
                    response = data;
                });
            }
            catch(e){
                console.log("Falla metodo addLikeGaleria: ", e);
            }
            return new Promise((resolve)=>{
                if(response!=null){
                resolve(response);
                let dataFinal = {
                    likeImagen: response,
                    action: true,
                    data: data_
                }
                commit("SET_LIKE_IMAGEN_GALERIA", dataFinal);
                // commit("SET_LIKE_IMAGEN_GALERIA", response, true, data_);
                }
                else {
                resolve(false);
                }
        
            });
        },

        async delLikeGaleria({commit}, data_){
            let response = null;
            let data = [];
            let params = {
                mutation: QUITAR_LIKE,
                variables: data_
            }
            try{
                await apolloClient.mutate(params).then(res => {
                    //console.log('SET_LIKE_IMAGEN_GALERIA', res.data.quitarLikeImagen);
                    if (!res.loading) data = res.data.eliminarLikeEmpresa;
                    response = data;
                });
            }
            catch(e){
                console.log("Falla metodo delLikeGaleria: ", e);
            }
            return new Promise((resolve)=>{
                if(response!=null){
                resolve(response);
                let dataFinal = {
                    likeImagen: response,
                    action: false,
                    data: data_
                }
                commit("SET_LIKE_IMAGEN_GALERIA", dataFinal);
                }
                else {
                resolve(false);
                }
        
            });
        },
        /** metodo que envía lista de galerias paginadas, es un objeto que contiene, pagina y galerias asociada a esa pagina en un array
         * ,de fallar returna un false
         * **/
        async getPaginasGaleria({ commit }, payload){
            let response = null;
            let params = {
                query: GET_PAGINAS_IMAGENES_GALERIAS,
                variables: payload
            }
            try {
            await apolloClient.query(params).then(res => {
                //console.log("respuest de server getPaginasGaleria: ", res.data.PaginasImagenesGaleria);
                if (!res.loading) response = res.data.PaginasImagenesGaleria;
            });
            }
            catch(e){
            console.log("Falla error, getPaginasGaleria ", e);
            }
            return new Promise((resolve)=>{
                if(response!=null){
                    if (response.length==0){
                        resolve(false);
                    }
                    else {
                        resolve(response);
                        commit("SET_PAGINAS_GALERIA", response);
                    }
                }
                else {
                    resolve(false);
                }
            });
        },

        async getImagenesGaleria({ dispatch, commit }, payload) {
            let response = null;
            const paginatedImagenes = await dispatch("getPaginasGaleria", payload.data2_);
            let pagina = payload.pagina;
            let ids_imagenes = [];
            if (paginatedImagenes){
                paginatedImagenes.forEach((data)=>{
                    if(data.pagina == pagina){
                        ids_imagenes = data.galerias;
                    }
                }); 
            }
            let data_ = {
                id_empresa: payload.data2_.id_empresa,
                id_usuario: payload.data2_.id_usuario,
                id_imagen: ids_imagenes
            }
            let params = {
                query: GET_IMAGENES_GALERIA,
                variables: data_
            }
            //console.log("params: ", params, "response: ", response);
            //commit("SET_IMAGENES_GALERIA", response);
            try {
                await apolloClient.query(params).then(res => {
                    //console.log("respuest de server getImagenesGaleria: ", res.data.ListImagenes);
                    if (!res.loading) response = res.data.ListImagenes;
                });
            } catch(e){
                console.log("Falla error, getImagenesGaleria ", e);
            }
            return new Promise((resolve)=>{
                console.log(response)
                if(response != null){
                    if (response.length == 0){
                        resolve(false);
                    }
                    else {
                        resolve(response);
                        commit("SET_IMAGENES", response);
                    }
                }
                else {
                    resolve(false);
                }
            });
        }

    }
};